export default __webpack_public_path__ + "static/media/ecg_sent.89550278.svg";